import http from '@utils/http';

/** Extract user object from PATCH/GET /auth/me style responses. */
export function extractMeUser(responseData) {
    const raw = responseData?.data?.data ?? responseData?.data ?? responseData;
    const user = raw?.user ?? raw;
    if (!user || typeof user !== 'object') return null;
    const avatarUrl = user.avatarUrl ?? user.avatar ?? user.profileImage ?? null;
    return avatarUrl != null && user.avatarUrl == null ? { ...user, avatarUrl } : user;
}

/** POST /api/v1/auth/verify-password */
export const verifyPassword = async (password) => {
    const response = await http.post('/auth/verify-password', { password });
    return response.data;
};

/** POST /api/v1/auth/modify-password */
export const modifyPassword = async ({ currentPassword, newPassword }) => {
    const response = await http.post('/auth/modify-password', { currentPassword, newPassword });
    return response.data;
};

/**
 * PATCH /api/v1/auth/me — JSON when no file; multipart when avatar (or mixed fields + file).
 * @param {{ name?: string, email?: string, phone?: string, avatarFile?: File }} payload
 */
export const updateMeProfile = async ({ name, email, phone, avatarFile } = {}) => {
    if (avatarFile) {
        const formData = new FormData();
        if (name != null && name !== '') formData.append('name', name);
        if (email != null && email !== '') formData.append('email', email);
        if (phone != null && phone !== '') formData.append('phone', phone);
        formData.append('avatar', avatarFile);
        const response = await http.patch('/auth/me', formData);
        return response.data;
    }

    const body = {};
    if (name != null) body.name = name;
    if (email != null) body.email = email;
    if (phone != null) body.phone = phone;

    const response = await http.patch('/auth/me', body);
    return response.data;
};
